import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lf-dated-browser',
    templateUrl: 'dated-browser.component.html',
    styleUrls: ['./dated-browser.component.scss'],
    standalone: true,
    imports: [
        CommonModule
    ],
})

export class DatedBrowserComponent implements OnInit
{

    public showDatedBrowserAlert = false;

    constructor() {
    }

    ngOnInit() {
        this.showDatedBrowserAlert = this.detectBroswer();
    }

    public detectBroswer() {
        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        const ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // IE 12 / Spartan
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge (IE 12+)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        const msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older
            const version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            return true;
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11
            const rv = ua.indexOf('rv:');
            const version = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            return true;
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (12+), return when below v16. Current v18.
            if (parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10) < 16) {
                return true;
            }
        }

        // other browser
        return false;
    }
}
